import api from "./api";

// Super-Admin-only, cross-tenant company administration. The api instance still
// stamps the caller's own `company` header, but the backend ignores it for these
// routes (they operate across tenants and are gated by the Super Admin guard).
const list = () => {
  return api.get("/api/company-management/list");
};

const create = (data) => {
  return api.post("/api/company-management/create", data);
};

const remove = (id) => {
  return api.post("/api/company-management/delete", { id });
};

const addAdmin = (data) => {
  return api.post("/api/company-management/add-admin", data);
};

const resendInvite = (inviteId) => {
  return api.post("/api/company-management/resend-invite", { inviteId });
};

const CompanyManagementService = {
  list,
  create,
  remove,
  addAdmin,
  resendInvite,
};

export default CompanyManagementService;
